__turbopack_context__.v({
  "alertYellow": "PHESya_alertYellow",
  "baseContent": "PHESya_baseContent",
  "black": "PHESya_black",
  "black90": "PHESya_black90",
  "childrenContainer": "PHESya_childrenContainer",
  "container": "PHESya_container",
  "content": "PHESya_content",
  "cyan": "PHESya_cyan",
  "darkStone": "PHESya_darkStone",
  "fuschiaPunch": "PHESya_fuschiaPunch",
  "limeSorbet": "PHESya_limeSorbet",
  "olive100": "PHESya_olive100",
  "olive20": "PHESya_olive20",
  "softBlack": "PHESya_softBlack",
  "teal100": "PHESya_teal100",
  "teal20": "PHESya_teal20",
  "titleContainer": "PHESya_titleContainer",
  "warmStone": "PHESya_warmStone",
  "white": "PHESya_white",
});
